export const OnsiteEditDtoDescriptions = {
  _schema:
    "Onsite edits modify DOM content — ONLY use for text replacement, image swaps, HTML insertion, and element removal. Do NOT use for visual styling changes (colors, backgrounds, fonts, borders, layout) — use onsiteInjection.customCss instead.",
  id: "Server-generated. Read-only.",
  onsiteEditType: "Content modification strategy (html, text, image, or hide).",
  variationId: "References the parent variation.",
  find: "Pattern to locate on the page. Interpreted as regex when isRegex is true.",
  title: "Dashboard label for identifying this edit.",
  isRegex: "When true, 'find' is treated as a regular expression.",
  replace:
    "Replacement content. Interpretation depends on onsiteEditType: HTML markup, plain text, or image URL.",
  querySelectors:
    "CSS selectors scoping which DOM elements this edit targets (e.g., '.product-title').",
  skip: "When true, this edit is temporarily disabled without being deleted.",
  remove:
    "When true, the matched element is removed from the DOM instead of having its content replaced.",
  groupId: "Groups related edits together so they can be managed as a unit.",
  insertType:
    "DOM insertion position relative to the target (beforebegin, afterbegin, beforeend, afterend). Null means content replacement.",
  createdAtUrl:
    "Server-generated. Read-only. Storefront URL where this edit was originally created via the visual editor.",
  createdAtTs: "Server-generated. Read-only. Unix timestamp in seconds.",
  imageSearchUrl:
    "URL pathname for locating images to replace. When set, images are found by URL match; when null, querySelectors is used instead.",
} as const;

export const CreateOnsiteEditDtoDescriptions = {
  _schema:
    "Creates a DOM content edit. ONLY use for text replacement, HTML insertion, image swaps, and element removal. Do NOT create an onsiteEdit for visual styling changes (colors, backgrounds, fonts, layout) — use onsiteInjection.customCss instead.",
  onsiteEditType:
    "Content modification strategy (rich HTML, plain text, image swap, or element removal).",
  find: "Pattern to find on the page. Set isRegex=true for regex. Null when using querySelectors with 'hide' or 'image' type.",
  title: "Dashboard label for organizing multiple edits.",
  isRegex: "Set to true to interpret 'find' as a regex pattern.",
  replace:
    "Replacement content: HTML markup for 'html' type, plain text for 'text', image URL for 'image'.",
  querySelectors:
    "CSS selectors scoping where the edit applies (e.g., '.product-title').",
  skip: "Set to true to temporarily disable without deleting.",
  remove:
    "Set to true to remove the matched element entirely instead of replacing.",
  groupId: "Edits sharing a groupId are managed together as a unit.",
  insertType:
    "DOM insertion position relative to target element. Null for content replacement (default).",
  imageSearchUrl:
    "URL pathname to match for image replacement. Mutually exclusive with querySelectors for image edits.",
} as const;

export const ExternalOnsiteEditDescriptions = {
  id: "Copy from GET response. Identifies which onsite edit to preserve.",
  variationId: "Copy from GET response. Must match the parent variation's id.",
} as const;
